/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaStatoOpera } from '@models';

@Pipe({
    name: 'anagraficaStatoOpera',
})
export class AnagraficaStatoOperaPipe implements PipeTransform {

    transform(value: number, items: AnagraficaStatoOpera[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
